import api, { withLoading } from '@/api/api';

const resource = `v1/ict/timesheets`;
const LOADING_KEY = 'ict-timesheet';

export default {
    getAll(empresaId, params = {}) {
        const { query } = params;
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}${query ? `?${query}` : ""}`).then(res => res.data)
        );
    },
    create(empresaId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}`, data).then(res => res.data)
        );
    },
    update(empresaId, id, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}/${id}`, data).then(res => res.data)
        );
    },
    remove(empresaId, id) {
        return withLoading(LOADING_KEY, () =>
            api.delete(`${resource}/${empresaId}/${id}`).then(res => res.data)
        );
    },
    exportar(empresaId, params = {}) {
        const { query } = params;
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}/exportar${query ? `?${query}` : ""}`).then(res => res.data)
        );
    },
    getSemanal(empresaId, params = {}) {
        const { query } = params;
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}/semanal${query ? `?${query}` : ""}`).then(res => res.data)
        );
    },
    saveSemanal(empresaId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}/semanal`, data).then(res => res.data)
        );
    },
    deleteSemanal(empresaId, ids) {
        return withLoading(LOADING_KEY, () =>
            api.delete(`${resource}/${empresaId}/semanal`, { data: { datas: ids } }).then(res => res.data)
        );
    },
}
